import { useForm, Controller } from "react-hook-form";
import { OBJECT_DESCRIPTION_RULE, FORM_SELECT_RULE } from "../../../utils/validation-utils";
import JobPostingStatusUpdateModel from "../../../models/company/jobPosting/request/JobPostingStatusUpdateModel";
import IdNameModel from "../../../models/common/IdNameModel";
import toasterUtils from "../../../utils/toaster-utils";
import { GuidEnum } from "../../../models/enums/GuidEnum";
import { Autocomplete, Button, FormControl, FormHelperText, InputLabel, MenuItem, Select, TextField } from "@mui/material";

interface JobPostingStatusUpdateProps {
    objStatusUpdate: JobPostingStatusUpdateModel;
    statusList: IdNameModel[];
    recruiterList: IdNameModel[];
    onCloseStatusUpdate: () => void;
    onStatusUpdateSave: (objJobPosting: JobPostingStatusUpdateModel) => void;
}

const JobPostingStatusUpdateComponent = (props: JobPostingStatusUpdateProps) => {
    const {
        register,
        handleSubmit,
        control,
        formState: { errors, isValid },
        watch,
    } = useForm<JobPostingStatusUpdateModel>({
        mode: "onChange",
        defaultValues: props.objStatusUpdate
    });

    const statusId = watch("statusId");

    const isClosed = props.statusList.find((x: IdNameModel) => x.id === 15)?.id === statusId;

    const onSubmit = (formData: JobPostingStatusUpdateModel) => {
        if (!isValid) {
            toasterUtils.showError("Please fill all mandatory fields");
            return;
        }
        props.onStatusUpdateSave(formData);
    };

    return (
        <form className="contact quform" onSubmit={handleSubmit(onSubmit)}>
            <div className="row">
                <div className="col-md-6">
                    <div className="quform-element form-group">
                        <div className="quform-input">
                            <Controller name="statusId" control={control} defaultValue={0} rules={FORM_SELECT_RULE}
                                render={({ field }) => (
                                    <Autocomplete {...field} value={props.statusList.find(x => x.id === field.value) || null}
                                        onChange={(_, newValue) => field.onChange(newValue ? newValue.id : 0)} options={props.statusList} getOptionLabel={(option) => option.name || ""}
                                        renderInput={(params) => (
                                            <TextField {...params} label="Status" size="small" required margin="normal" fullWidth error={!!errors.statusId} helperText={errors.statusId?.message} />
                                        )}
                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                    />
                                )}
                            />
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <FormControl fullWidth margin="normal" error={!!errors.comments}>
                        <TextField label="Comments" multiline rows={3} size="small"
                            {...register("comments", OBJECT_DESCRIPTION_RULE)} error={!!errors.comments} helperText={errors.comments?.message} autoComplete="off" />
                    </FormControl>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6">
                    <Controller name="assignToId" control={control} defaultValue={GuidEnum.Empty} rules={FORM_SELECT_RULE}
                        render={({ field }) => (
                            <Autocomplete {...field} value={props.recruiterList.find(x => x.guId === field.value) || null}
                                onChange={(_, newValue) => field.onChange(newValue ? newValue.guId : GuidEnum.Empty)} options={props.recruiterList} getOptionLabel={(option) => option.name || ""}
                                renderInput={(params) => (
                                    <TextField {...params} label="Assign To" size="small" required margin="normal" fullWidth error={!!errors.assignToId} helperText={errors.assignToId?.message} />
                                )}
                                isOptionEqualToValue={(option, value) => option.guId === value.guId}
                            />
                        )}
                    />
                </div>
            </div>
            <div className="row">
                <div className="col-md-6"></div>
                <div className="col-md-6 text-end">
                    <Button variant="contained" color="success" type="submit" disabled={!isValid}>
                        Save
                    </Button>
                    <Button variant="contained" color="error" className="m-l-xxs" type="button" onClick={props.onCloseStatusUpdate}>
                        Close
                    </Button>
                </div>
            </div>
        </form>
    );
};
export default JobPostingStatusUpdateComponent;